const initialState = {
  totalPictures: 0,
};

export const photosReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TOTAL_PICTURES":
      return { ...state, totalPictures: action.payload };
    default:
      return state;
  }
};
